module.exports = __webpack_public_path__ + "img/HONDA.4f319ecd.jpg";